import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import localizeHelpers from "services/localize/helpers"

import LazyImportPlugin from "./LazyImportPlugin"

const lng = localizeHelpers.getLanguageFromLocale(localizeHelpers.getInitialLocale())

i18n
  .use(LazyImportPlugin)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng,
    interpolation: {
      escapeValue: false
    },
    react: {
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "li", "ul"]
    }
    // ns: ["common"]
  })

export default i18n
